import React from 'react';
import InventarioSummary from '../InventarioSummary/InventarioSummary';
import InventoryAssetHealth from '../InventoryAssetHealth/InventoryAssetHealth';
import InventoryRecentActivity from '../InventoryRecentActivity/InventoryRecentActivity';
import './InventoryDashboard.css';

function InventoryDashboard({ data = [] }) {
    return (
        <section className="inventory-dashboard" aria-labelledby="inventory-dashboard-title">
            <h2 id="inventory-dashboard-title" className="inventory-dashboard__title">
                Painel do inventário
            </h2>

            <div className="inventory-dashboard__overview">
                <h3 className="inventory-dashboard__section-title">Visão geral</h3>
                <InventarioSummary data={data} />
            </div>

            <div className="inventory-dashboard__health">
                <h3 className="inventory-dashboard__section-title">Saúde dos ativos</h3>
                <InventoryAssetHealth data={data} />
            </div>

            <div className="inventory-dashboard__activity">
                <h3 className="inventory-dashboard__section-title">Atividade recente</h3>
                <InventoryRecentActivity />
            </div>
        </section>
    );
}

export default InventoryDashboard;
